import type EnType from '../en-US/user';

export default {
  'user.login.password.required': 'Por favor ingresa tu contraseña.',
  'user.login.password.required.placeholder': 'Ingresar contraseña',
  'user.loginOrRegister.email': 'Correo electrónico',
  'user.loginOrRegister.captcha.placeholder': 'Pegar código de verificación',
  'user.loginOrRegister.captcha.sendEmail': 'Enviar Código',
  'user.loginOrRegister.rule.required.captcha': 'Por favor ingresa el código de verificación',
  'user.loginOrRegister.rule.required.mail': 'Por favor ingresa el correo electrónico',
  'user.loginOrRegister.rule.pattern.mail': 'Por favor ingresa un formato de correo electrónico correcto',
  'user.login.password.tooManyErrors':
    'Has ingresado demasiados errores de contraseña, por favor intenta más tarde.',
  'user.request.message.rateLimit': 'Solicitando demasiado frecuentemente, acceso restringido, intenta más tarde',
  'user.login.message.invalidCaptcha': 'El código de verificación es inválido',
  'user.login.message.invalidCaptcha.tip': 'El código de verificación es incorrecto, por favor intenta de nuevo',
  'user.login.password.error': 'Error de contraseña, ¡por favor intenta de nuevo!',
} satisfies typeof EnType;
